import { CSSObject } from "@emotion/react";
import { constants, typographyStyles } from "@newsela/angelou";

const { colors } = constants;
const neutral600 = colors.ui.neutral[600];

export const modalFooterCss: CSSObject = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "0 16px",
  paddingBottom: "32px",
  minHeight: "unset",
  flexWrap: "wrap",
  "> :only-child": {
    marginLeft: "auto",
  },
};

export const footerButtonWrapperCss: CSSObject = {
  display: "flex",
  gap: "16px",
  alignItems: "center",
  flexWrap: "wrap",
};

export const warningTextCss: CSSObject = {
  color: neutral600,
  ...typographyStyles.fontSize.textS,
  lineHeight: typographyStyles.lineHeight.textSLineHeights,
};

export const buttonContainerStyles = {
  root: {
    display: "flex",
    justifyContent: "flex-end",
  } as CSSObject,
};
